module.exports = __webpack_public_path__ + "img/icon_import.45b53ec4.svg";